import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface ChevronProps {
  size?: number;
  color?: string;
}

export const ChevronUpIcon: React.FC<ChevronProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => (
  <Svg
    width={size}
    height={size * 0.6} // Make it wider than tall
    viewBox="0 0 24 15"
    fill="none"
  >
    <Path
      d="M3 10.5L12 4.5L21 10.5"
      stroke={color}
      strokeWidth={3} // Bolder stroke
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export const ChevronDownIcon: React.FC<ChevronProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => (
  <Svg
    width={size}
    height={size * 0.6} // Make it wider than tall
    viewBox="0 0 24 15"
    fill="none"
  >
    <Path
      d="M3 4.5L12 10.5L21 4.5"
      stroke={color}
      strokeWidth={3} // Bolder stroke
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);